import {
    useEffect,
    useRef,
    useState
} from 'react';
import './Profile.css'
import Axios from 'axios';
import Options from './Options';
import WineList from './WineList';
import Statistics from './Statistics';
import vinelyLogo from "./../../common/logo120.png";
import QRCodeStyling from 'qr-code-styling';
import { IProfileContractV1 } from "../../../../common/src/contracts/v1/IProfileContractV1"
import { IWineRecordContractV1 } from "../../../../common/src/contracts/v1/IWineRecordContractV1"
import UserNotFound from './UserNotFound';
import { GetApiUrl } from '../../ServiceEndpoint';


interface ProfileProps {
    username: string | undefined,
}

// Shape returned by the new Hono /api/v1/profiles/:username endpoint —
// snake_case Postgres columns + nested wine_notes. Inlined here as a
// stopgap; Phase 5 (Next.js rewrite) will consume Supabase types directly.
interface ProfileResponse {
    user: {
        id: string
        username: string
        description: string | null
        profile_photo_url: string | null
        joined_date: string
    }
    wines: Array<{
        id: string
        user_id: string
        added_date: string
        rating: number | null
        grape: string | null
        location: string | null
        winery: string | null
        vintage_year: number | null
        images: string[]
        wine_notes: {
            acidity: number | null
            alcohol: number | null
            body: number | null
            clarity: number | null
            minerality: number | null
            sweetness: number | null
            tannins: number | null
            texture: number | null
            viscosity: number | null
            color: string | null
            aroma: string[]
            notes: string | null
        } | null
    }>
    followerCount: number
    followingCount: number
}

function adaptToV1(res: ProfileResponse): IProfileContractV1 {
    return {
        date: res.user.joined_date,
        description: res.user.description ?? '',
        profilePhoto: res.user.profile_photo_url ?? '',
        wineList: res.wines.map((w): IWineRecordContractV1 => ({
            addedDate: w.added_date,
            key: w.id,
            userKey: w.user_id,
            rating: w.rating ?? undefined,
            images: w.images,
            details: {
                grape: w.grape ?? '',
                location: w.location ?? '',
                winery: w.winery ?? '',
                year: w.vintage_year ?? 0,
            },
            notes: w.wine_notes ? {
                acidity: w.wine_notes.acidity ?? 0,
                alcohol: w.wine_notes.alcohol ?? 0,
                body: w.wine_notes.body ?? 0,
                clarity: w.wine_notes.clarity ?? 0,
                minerality: w.wine_notes.minerality ?? 0,
                sweetness: w.wine_notes.sweetness ?? 0,
                tannins: w.wine_notes.tannins ?? 0,
                texture: w.wine_notes.texture ?? 0,
                viscosity: w.wine_notes.viscosity ?? 0,
                color: w.wine_notes.color ?? '',
                aroma: w.wine_notes.aroma,
                notes: w.wine_notes.notes ?? '',
            } : undefined,
        })),
    }
}

async function GetProfileAsync(
    username: string
): Promise<IProfileContractV1 | null> {

    const url = `${GetApiUrl()}/api/v1/profiles/${username}`
    var result = await Axios
        .get<ProfileResponse>(url)
        .catch(e => {
            console.error(e)
            return null
        })

    if (result?.status === 200) {
        return adaptToV1(result.data)

    } else {
        return null
    }
}

const Profile = (props: ProfileProps) => {

    const qrRef = useRef<HTMLDivElement>(null);
    const [userNotFound, setUserNotFound] = useState(false)
    const [wineList, setWineList] = useState()
    const [profile, setProfile] = useState<IProfileContractV1>()

    useEffect(() => {
        try {
            GetProfileAsync(props.username!)
                .then((profile) => {
                    if (profile == null) {
                        setUserNotFound(true);
                    } else {
                        setProfile(profile);
                    }
                });
        } catch (e) { }

    }, [props.username])

    useEffect(() => {
        let tempList: any = []
        profile?.wineList.forEach((wine, index) => {
            tempList.push(wine)
        })
        setWineList(tempList)

        // Set QR code
        const qr = new QRCodeStyling({
            width: 150,
            height: 150,
            type: 'svg',
            image: vinelyLogo,
            dotsOptions: {
                color: "#333",
                type: "dots"
            },
            backgroundOptions: {
                color: 'transparent'
            },
            data: GetApiUrl() + `/${props.username}`
        });

        qr.append(qrRef.current!)

    }, [props.username, profile])

    if (userNotFound) {
        return (
            <UserNotFound />
        )
    } else if (profile) {
        return (
            <div id="container">
                <div id="profile-cotaniner">

                    <div id="profile-img-container">
                        {
                            profile?.profilePhoto !== '' ||
                                profile?.profilePhoto !== null ||
                                profile?.profilePhoto !== undefined ?
                                <img src={profile?.profilePhoto} alt="User profile" />
                                : null
                        }
                    </div>

                    <div id="subview-container">
                        <div id="qr-container">
                            <div ref={qrRef} />
                        </div>

                        <div id="profile-detail-container">
                            <h2>
                                {props.username}
                            </h2>

                            <div id="joined-date">
                                Joined on {profile?.date}
                            </div>

                            {
                                profile?.description !== '' ?
                                    <div id="description">
                                        {profile?.description}
                                    </div> : null
                            }
                        </div>
                    </div>

                    <Statistics wineList={wineList} />
                </div>

                <div>
                    <Options wineList={wineList} setWineList={setWineList} />
                    <WineList wineList={wineList} />
                </div>

                <span
                    id="join-text-container"
                    onClick={() => {
                        window.open(GetApiUrl())
                    }}>
                    <span id="join-text">
                        Join <b>Vinely</b> to create your Cellar! →
                    </span>
                </span>
            </div>

        )
    } else {
        return null
    }
}

export default Profile